import React from "react";
import {
  AList,
  AListItem,
  AListItemContent,
  AListItemSubtitle,
  AListItemTitle
} from "@cisco-sbg-ui/magna-react";
import {t} from "i18next";
import {getFormattedDate} from "../../../utils/dateutils";
import AuditLogItem from "./AuditLogItem";
import css from "./Worklog.module.scss";

const excludedFields = ["modified", "owner", "schema_version"];
const tAuditLogPanel = "incidentDetail.worklogTab.auditLogPanel";

export default function AuditLogList({auditLog, users}) {
  return (
    <AList
      hoverable={false}
      style={{
        overflowY: "auto",
        minHeight: "400px",
        border: "none",
        backgroundColor: "initial"
      }}
      data-testid={"AuditLogPanel-List"}>
      {auditLog.map(({timestamp, fields}, idx) => {
        // xtra field vars
        const hasEvent = fields?.length > 0;
        const eventWithoutField =
          hasEvent && fields.length === 1 && fields[0].field === "modified";
        const hasEventField = hasEvent && !eventWithoutField;
        const staticTitle = eventWithoutField
          ? t(`${tAuditLogPanel}.modified`)
          : t(`${tAuditLogPanel}.created`);

        return (
          <AListItem
            key={`item-${idx}`}
            selected={false}
            data-testid={`AuditLogPanel-ListItem-${idx}`}
            style={{
              flexDirection: "column",
              alignItems: "start",
              border: "1px solid #E0E0E0",
              borderRadius: "8px"
            }}
            className={css.listItem}>
            {hasEventField ? (
              fields.map((item, idx) => {
                const {field, change} = item;
                const action = change?.before
                  ? t(`${tAuditLogPanel}.actionChanged`)
                  : t(`${tAuditLogPanel}.actionAdded`);
                const title = `${field?.replace("_", " ")} ${action}`;
                return (
                  !excludedFields.includes(field) && (
                    <div key={idx}>
                      <div className="d-flex align-center">
                        <AListItemTitle className={"text-capitalize"}>
                          {title}
                        </AListItemTitle>
                        <span>|</span>
                        <AListItemSubtitle className={css.listItemTimestamp}>
                          {getFormattedDate(timestamp)}
                        </AListItemSubtitle>
                      </div>
                      <AListItemContent className="pl-0">
                        <AuditLogItem item={item} users={users} />
                      </AListItemContent>
                    </div>
                  )
                );
              })
            ) : (
              <div className="d-flex align-center">
                <AListItemTitle>{staticTitle}</AListItemTitle>
                <span>|</span>
                <AListItemSubtitle className={css.listItemTimestamp}>
                  {getFormattedDate(timestamp)}
                </AListItemSubtitle>
              </div>
            )}
          </AListItem>
        );
      })}
    </AList>
  );
}
